export default [{
  path: '/museumActivity',
  name: 'museumActivity',
  component: () => import('@/views/activity/wwActivity/index'),
}]
